(() => {
  'use strict';

  const CONFIG = {
    defaultOptions: {
      activePopupBehavior: 'ALWAYS_DISMISS',
      respectPopupStatus: true
    }
  };

  let psReady = false;

  const waitForPostscript = (callback, attempts = 0) => {
    if (window.postscript?.popups?.open && typeof window.postscript.popups.open === 'function') {
      if (!psReady) {
        psReady = true;
        try {
          window.postscript.popups.reset(); // Prevent auto-open
        } catch (e) {
          console.warn('[Postscript] Could not reset popups:', e);
        }
      }
      callback();
      return;
    }

    if (attempts > 50) {
      console.warn('[Postscript] SDK failed to load after 10s');
      return;
    }

    setTimeout(() => waitForPostscript(callback, attempts + 1), 200);
  };

  // Open a popup by ID
  const openPopup = (id) => {
    waitForPostscript(() => {
      try {
        window.postscript.popups.open(id, CONFIG.defaultOptions);
      } catch (err) {
        console.error('[Postscript] Failed to open popup:', err);
      }
    });
  };

  window.postscriptAB = {

    show: (id) => {
      openPopup(id);
    },

    delay: (id, seconds = 5) => {
      setTimeout(() => {
        openPopup(id);
      }, seconds * 1000);
    },

    hide: () => {
      if (window._conv_q) {
        window._conv_q.push(['triggerConversion', 'popup_hidden']);
      }
    },

    reset: () => {
      waitForPostscript(() => {
        try {
          window.postscript.popups.reset();
        } catch (e) {
          console.warn('[Postscript] Reset failed:', e);
        }
      });
    }
  };

})();
